import { withRouter, NextRouter } from 'next/router'
import { connect, MapStateToProps } from 'react-redux'
import { SetState } from '#/store/actions/cma'
import { UpdateStates } from '#/store/actions/ui'
import { AddToList, RemoveFromList } from '#/store/actions/workspace'
import { currentRole } from '#/store/selectors/user'
import { isInList } from '#/store/selectors/workspace'
import type { OwnProps, StateProps } from './types'
import PropertyCard from './index'

const mapStateToProps: MapStateToProps<StateProps, OwnProps, TopHap.StoreState> =
  (state, { item, currentRole: role }) => ({
    currentRole: role || currentRole(state),
    isMobile: state.global.isMobile.any,
    isFavorite: isInList(state, item.id, 'favorites'),
    isHidden: isInList(state, item.id, 'hidden'),
    cmaData: state.cma.preferences.data
  })

const mapDispatchToProps = {
  showCTAPopup: (visible: boolean, requireRole?: TopHap.UserRole) =>
    UpdateStates({ ctaPopup: { visible, requireRole } }),
  addToList: AddToList,
  removeFromList: RemoveFromList,
  setCMAData: (data: TopHap.CMAInfo[]) => SetState({ option: 'preferences.data', value: data })
}

const Connected = connect(
  mapStateToProps,
  mapDispatchToProps
)(PropertyCard) as React.FC<OwnProps & { router: NextRouter }>
export default withRouter<OwnProps & { router: NextRouter }>(Connected)
